export { default as VpUpdateSubscriptionDialog } from './VpUpdateSubscriptionDialog';



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpUpdateSubscriptionDialog/index.js